module.exports = __webpack_public_path__ + "images/hero-image.d4cd414221dab309c9e40b4c09c154f3.jpg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/hero-image.jpg
// module id = 1004
// module chunks = 0